/* eslint-disable react/no-array-index-key */
import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Grid,
  Box,
  Typography as Text,
  Link,
  Typography,
  Button,
} from '@material-ui/core'

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import { facultyStaffServiceStyles } from './facultyStaffCenterStyles'
import {
  TabPanel,
  a11yProps,
} from '../../DashboardComponents/TabPanel/TabPanel'
import Widget, { SmallIconLink } from '../Widget'
import SearchBar from '../../../../CommonComponents/SearchBar/SearchBar'

import MyCasesObject from './MyCasesObject'
import ToDoObject from './ToDoObject'
import Announcement from './Announcement'
import {
  fetchStaffAnnouncements,
  fetchStaffOpenCases,
  fetchStaffClosedCases,
  updateQuery,
  updateTabValue,
  updateTabValue2,
  updateChatDialogBoolean,
} from './facultyStaffCenterSlice'
import Loading from '../helpers/Loading'
import {
  RutgersTab,
  RutgersTabs,
} from '../../DashboardComponents/Tabs/RutgersTabs'
import CaseIndicator from '../../DashboardComponents/CaseIndicator/CaseIndicator'
import { logDashboardEvent } from '../../events'
import Footer from '../../DashboardComponents/Footer/Footer'
import { ErrorMessage } from '../../DashboardComponents/ErrorMessages/ErrorMsg'
import DashboardDialog from '../../DashboardComponents/DashboardDialog/DashboardDialog'
import { useTabTracking } from '../../../../helpers/useTabTracking'
import { trackWidgetClick } from '../../../../helpers/trackWidgetClick'

/**
 * Faculty/Staff Service Center Widget
 * Shows announcements and cases for the account as well as redirect links
 * @param {*} param0
 * @returns
 */
// eslint-disable-next-line no-unused-vars
export default function FacultyStaffCenter({ className, title, widgetId }) {
  const classes = facultyStaffServiceStyles()
  const dispatch = useDispatch()
  const { announcements, status, chatDialogBoolean } = useSelector(
    (s) => s.facultyStaffCenter,
  )
  React.useEffect(() => {
    dispatch(fetchStaffAnnouncements())
    dispatch(fetchStaffOpenCases())
  }, [])
  return (
    <Widget className={className}>
      <Widget.Header title={title} />
      <Widget.Content className={classes.content}>
        {renderFSCState(announcements, status, widgetId, chatDialogBoolean)}
      </Widget.Content>
    </Widget>
  )
}

function renderFSCState(announcements, status, widgetId, chatDialogBoolean) {
  switch (status) {
    case 'fulfilled':
      return (
        <Loaded
          announcements={announcements}
          widgetId={widgetId}
          chatDialogBoolean={chatDialogBoolean}
        />
      )
    case 'pending':
      return <Loading />
    case 'error':
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <ErrorMessage />
        </Grid>
      )
    default:
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item></Grid>
        </Grid>
      )
  }
}
function renderOpenCaseState(caseStatus, widgetId, dispatch) {
  switch (caseStatus) {
    case 'fulfilled':
      return <MyOpenCases widgetId={widgetId} dispatch={dispatch} />
    case 'pending':
      return <Loading />
    case 'error':
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <ErrorMessage />
        </Grid>
      )
    default:
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item></Grid>
        </Grid>
      )
  }
}
function renderClosedCaseState(caseStatus, widgetId, dispatch) {
  switch (caseStatus) {
    case 'fulfilled':
      return <MyClosedCases widgetId={widgetId} dispatch={dispatch} />
    case 'pending':
      return <Loading />
    case 'error':
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <ErrorMessage />
        </Grid>
      )
    default:
      return (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item></Grid>
        </Grid>
      )
  }
}

function Loaded(props) {
  const { announcements, widgetId, chatDialogBoolean } = props
  const classes = facultyStaffServiceStyles()
  const dispatch = useDispatch()
  const darkMode = useSelector((s) => s.settings)

  const trackTabChange = useTabTracking(
    dispatch,
    'FacultyStaffCenter',
    ['Announcements', 'My Cases'],
    { widgetId },
  )
  const trackSubTabChange = useTabTracking(
    dispatch,
    'FacultyStaffCenter',
    ['Open', 'Closed', 'To-dos'],
    { widgetId },
  )
  const handleChange = (event, newValue) => {
    trackTabChange(event, newValue, () => dispatch(updateTabValue(newValue)))
  }
  const handleChange2 = (event, newValue2) => {
    trackSubTabChange(event, newValue2, () =>
      dispatch(updateTabValue2(newValue2)),
    )
  }

  const { myCasesOpen, value, value2, query, caseStatus } = useSelector(
    (s) => s.facultyStaffCenter,
  )
  // If the case is open and has a todo task, show it
  const toDoCases = myCasesOpen?.filter((cases) => cases.task_list.length !== 0)

  React.useEffect(() => {
    if (value === 1) {
      dispatch(fetchStaffOpenCases())
      dispatch(fetchStaffClosedCases())
    }
  }, [value])

  // Search bar onSearch: not functional yet
  // We want it to redirect the page to this link when user searches
  const searchOnRequest = (val) => {
    // Spaces are replaced by '%20' in the search link
    const redirectString = val.toString().split(' ').join('%20')
    const link = `${process.env.REACT_APP_FACULTYSTAFF_BASE_URL}/hrportal?id=search&spa=1&q=${redirectString}`

    trackWidgetClick(dispatch, 'FacultyStaffCenter', 'Search', { widgetId })
    // Opens new tab with search bar value
    window.open(link, '_blank')
    if (widgetId && dispatch) {
      logDashboardEvent(
        dispatch,
        'dashboardEvent',
        widgetId,
        redirectString,
        link,
      )
    }
  }

  const buttonTitle = 'Launch Rutgers OneSource Service Center'
  const footerLink = `${process.env.REACT_APP_FACULTYSTAFF_BASE_URL}/hrportal`
  const handleFooterLinkClick = (link) => {
    trackWidgetClick(dispatch, 'FacultyStaffCenter', buttonTitle, {
      widgetId,
    })
    // window.open(link)
    if (widgetId && dispatch) {
      logDashboardEvent(dispatch, 'dashboardEvent', widgetId, buttonTitle, link)
    }
  }

  const handleUpdateChatDialogBoolean = () => {
    dispatch(updateChatDialogBoolean())
  }

  return (
    <>
      <>
        <DashboardDialog
          open={chatDialogBoolean}
          dialogTitle={<Typography variant="h3">Chat | ServiceNow</Typography>}
          dispatch={dispatch}
          closeDialog={updateChatDialogBoolean}
          contentClasses={classes.embedChatContent}
          dialogContent={
            <iframe
              src={process.env.REACT_APP_FACULTYSTAFF_EMBEDCHAT_REDIRECT}
              style={{ width: 800, height: 600, borderWidth: 0 }}
              title="Chat | ServiceNow"
            />
          }
          maxWidth="100%"
        />
        <Grid container direction="column">
          <Grid item className={classes.imgContainer} container direction="row">
            <img
              className={classes.img}
              alt="OneSource"
              src={
                darkMode === true
                  ? './assets/images/one_source_dark.png'
                  : './assets/images/one_source_light.jpg'
              }
            />
            <Grid item style={{ marginLeft: 10 }}>
              <Button
                onClick={handleUpdateChatDialogBoolean}
                variant="contained"
                color="primary"
              >
                Chat Assistant
              </Button>
            </Grid>
          </Grid>

          <Grid item className={classes.searchBar}>
            <SearchBar
              searchOnSubmit
              placeholder="How can we help you?"
              value={query}
              onChange={(result) => dispatch(updateQuery(result))}
              onCancelSearch={() =>
                dispatch(updateQuery({ target: { value: '' } }))
              }
              onRequestSearch={() => searchOnRequest(query)}
              variant="outlined"
              moduleName={widgetId}
            />
          </Grid>
        </Grid>

        <Box className={classes.modalTabs}>
          <RutgersTabs
            value={value}
            onChange={handleChange}
            aria-label="Top Tab"
          >
            <RutgersTab
              className={classes.tabText}
              label="Announcements" // TODO: Why is this affecting other compoments and reading out wrong?
              {...a11yProps(0)}
            />
            <RutgersTab
              className={classes.tabText}
              label={
                <Box display="flex" style={{ alignItems: 'center' }}>
                  <Text className={classes.tabTextLabel}>My Cases</Text>
                  {myCasesOpen && myCasesOpen?.length > 0 && (
                    <CaseIndicator value={myCasesOpen?.length} />
                  )}
                </Box>
              }
              {...a11yProps(1)}
            />
          </RutgersTabs>
        </Box>
      </>
      <TabPanel value={value} index={0} className={classes.tabPanel}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.announcementList}
        >
          <Announcement
            announcements={announcements}
            widgetId={widgetId}
            dispatch={dispatch}
          />
        </Grid>
      </TabPanel>

      {/* My cases tab */}
      <TabPanel value={value} index={1} className={classes.tabPanel}>
        <Box className={classes.modalTabs}>
          <RutgersTabs
            level2
            value={value2}
            onChange={handleChange2}
            aria-label="Top Tab"
          >
            <RutgersTab
              className={classes.tabText}
              label="Open"
              {...a11yProps(2)}
            />
            <RutgersTab
              className={classes.tabText}
              label="Closed"
              {...a11yProps(3)}
            />
            <RutgersTab
              className={classes.tabText}
              label="To-dos"
              {...a11yProps(4)}
            />
          </RutgersTabs>
        </Box>

        {/* Open tab */}
        <TabPanel value={value2} index={0} className={classes.tabPanel}>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            className={classes.casesList}
          >
            {renderOpenCaseState(caseStatus, widgetId, dispatch)}
          </Grid>
        </TabPanel>

        {/* Closed tab */}
        <TabPanel value={value2} index={1} className={classes.tabPanel}>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            className={classes.casesList}
          >
            {renderClosedCaseState(caseStatus, widgetId, dispatch)}
          </Grid>
        </TabPanel>

        {/* To-dos tab */}
        <TabPanel value={value2} index={2} className={classes.tabPanel}>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            className={classes.casesList}
          >
            {toDoCases.length === 0 ? (
              <Grid container direction="column" alignItems="center">
                <Grid item>
                  <CheckCircleOutlineIcon className={classes.circleIcon} />
                </Grid>

                <Grid item>
                  <Text variant="subtitle1">You do not have any To-Dos</Text>
                </Grid>
              </Grid>
            ) : (
              <Grid container direction="column">
                <>
                  {toDoCases.map((cases, index) => (
                    <ToDoObject
                      key={index}
                      cases={cases}
                      widgetId={widgetId}
                      dispatch={dispatch}
                    />
                  ))}
                </>
              </Grid>
            )}
          </Grid>
        </TabPanel>
      </TabPanel>
      {/* Bottom container */}
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className={classes.bottomContainer}
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.grid1}
        >
          <Grid item>
            <SmallIconLink
              classes={classes}
              icon="fas fa-book"
              iconLabel={
                <Text component="span" className={classes.tabLink}>
                  Knowledge Base
                </Text>
              }
              link={`${process.env.REACT_APP_FACULTYSTAFF_BASE_URL}/hrportal?id=kb_view2`}
              widgetId={widgetId}
              dispatch={dispatch}
            />
          </Grid>

          <Grid item>
            <SmallIconLink
              classes={classes}
              icon="fas fa-book-open"
              iconLabel={
                <Text component="span" className={classes.tabLink}>
                  Service Catalog
                </Text>
              }
              link={`${process.env.REACT_APP_FACULTYSTAFF_BASE_URL}/hrportal?id=hrj_sc_category`}
              widgetId={widgetId}
              dispatch={dispatch}
            />
          </Grid>

          <Grid item>
            <SmallIconLink
              classes={classes}
              // className={classes.tabLink}
              icon="fas fa-question"
              iconLabel={
                <Text component="span" className={classes.tabLink}>
                  Ask a Question
                </Text>
              }
              link={`${process.env.REACT_APP_FACULTYSTAFF_BASE_URL}/hrportal?id=hrj_sc_cat_item&sys_id=27c78de49f331200d9011977677fcfb3`}
              widgetId={widgetId}
              dispatch={dispatch}
            />
          </Grid>

          <Grid item>
            <SmallIconLink
              classes={classes}
              // className={classes.tabLink}
              icon="fas fa-comments"
              iconLabel={
                <Text component="span" className={classes.tabLink}>
                  Feedback
                </Text>
              }
              link={`${process.env.REACT_APP_FACULTYSTAFF_BASE_URL}/hrportal?id=hrj_sc_cat_item&sys_id=538434491b9a73002c476356bd4bcb1a`}
              widgetId={widgetId}
              dispatch={dispatch}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.grid2}
        >
          <Footer toggleStroke>
            <Link
              onClick={() => handleFooterLinkClick()}
              href={footerLink}
              target="_blank"
              underline="none"
              color="primary"
              className={classes.footerLink}
            >
              <Text variant="subtitle1">{buttonTitle}</Text>
            </Link>
          </Footer>
        </Grid>
      </Grid>
    </>
  )
}

function MyOpenCases({ widgetId, dispatch }) {
  const classes = facultyStaffServiceStyles()
  const { myCasesOpen } = useSelector((s) => s.facultyStaffCenter)
  return (
    <>
      {myCasesOpen.length === 0 ? (
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <CheckCircleOutlineIcon className={classes.circleIcon} />
          </Grid>

          <Grid item>
            <Text variant="subtitle1">No Open Case Data</Text>
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="column">
          <>
            {myCasesOpen.map((cases, index) => (
              <MyCasesObject
                key={index}
                cases={cases}
                widgetId={widgetId}
                dispatch={dispatch}
              />
            ))}
          </>
        </Grid>
      )}
    </>
  )
}

function MyClosedCases({ widgetId, dispatch }) {
  const classes = facultyStaffServiceStyles()
  const { myCasesClosed } = useSelector((s) => s.facultyStaffCenter)
  return (
    <>
      {myCasesClosed.length === 0 ? (
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <CheckCircleOutlineIcon className={classes.circleIcon} />
          </Grid>

          <Grid item>
            <Text variant="subtitle1">No Closed Case Data</Text>
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="column">
          <>
            {myCasesClosed.map((cases, index) => (
              <MyCasesObject
                key={index}
                cases={cases}
                status="closed"
                widgetId={widgetId}
                dispatch={dispatch}
              />
            ))}
          </>
        </Grid>
      )}
    </>
  )
}
